import { Theme } from '@mui/material';

import { TimeTablingColorPreset, TimeTablingColorPresetName, TimeTablingItemColor } from './types';

export function createScheduleColorPresets(
  theme: Theme,
): Record<TimeTablingColorPresetName, TimeTablingColorPreset> {
  return {
    main: {
      bg: theme.palette.common.main5,
      bgHover: theme.palette.primary.main,
      text: theme.palette.primary.main,
      textSecondary: theme.palette.common.main3,
      textHover: theme.palette.common.white,
    },
    darkGreen: {
      bg: theme.palette.common.green4,
      bgHover: theme.palette.common.green1,
      text: theme.palette.common.green1,
      textSecondary: theme.palette.common.green2,
      textHover: theme.palette.common.white,
    },
    dijon: {
      bg: theme.palette.common.dijon4,
      bgHover: theme.palette.common.dijon1,
      text: theme.palette.common.dijon1,
      textSecondary: theme.palette.common.dijon6,
      textHover: theme.palette.common.white,
    },
    moss: {
      bg: theme.palette.common.moss4,
      bgHover: theme.palette.common.moss1,
      text: theme.palette.common.moss1,
      textSecondary: theme.palette.common.moss6,
      textHover: theme.palette.common.white,
    },
  };
}

export function createTimeSlotColorPresets(
  theme: Theme,
  hasGroups: boolean,
): Record<TimeTablingColorPresetName, TimeTablingColorPreset> {
  return {
    main: {
      bg: hasGroups ? theme.palette.common.lightBg : theme.palette.common.white,
      bgHover: hasGroups ? theme.palette.common.main5 : theme.palette.common.lightBg,
      text: theme.palette.primary.main,
      textSecondary: hasGroups ? theme.palette.common.main3 : theme.palette.primary.main,
      textHover: theme.palette.primary.main,
    },
    darkGreen: {
      bg: theme.palette.common.green5,
      bgHover: theme.palette.common.green4,
      text: theme.palette.common.green1,
      textSecondary: theme.palette.common.green1,
      textHover: theme.palette.common.green1,
    },
    dijon: {
      bg: hasGroups ? theme.palette.common.dijon5 : theme.palette.common.white,
      bgHover: hasGroups ? theme.palette.common.dijon4 : theme.palette.common.dijon5,
      text: hasGroups ? theme.palette.common.dijon1 : theme.palette.common.dijon1,
      textSecondary: hasGroups ? theme.palette.common.dijon3 : theme.palette.common.dijon1,
      textHover: theme.palette.common.dijon1,
    },
    moss: {
      bg: theme.palette.common.moss5,
      bgHover: theme.palette.common.moss4,
      text: theme.palette.common.moss1,
      textSecondary: theme.palette.common.moss1,
      textHover: theme.palette.common.moss1,
    },
  };
}

export function useTimeTablingColors(
  presets: Record<TimeTablingColorPresetName, TimeTablingColorPreset>,
) {
  const resolveColorConfig = (color: TimeTablingItemColor): TimeTablingColorPreset => {
    if (typeof color === 'string') {
      return presets[color];
    }
    return color;
  };

  return { presets, resolveColorConfig };
}
